import * as yup from 'yup';

export const manualLaneCreditCommentSchema = yup.object({
  comment: yup.string().min(10, 'comment too short').required(),
});
